import attributes from '../constants/attributes';

const booleanAttributesWithModifiedTraits = [attributes.NO_WRAP];

const getIsBooleanAttributeWithModifiedTraits = ({ attribute }) =>
  booleanAttributesWithModifiedTraits.includes(attribute);

export default getIsBooleanAttributeWithModifiedTraits;
